var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-in-shop"},[_c('h2',{staticClass:"text-center text-18 lg-text-24"},[_vm._t("default")],2),_c('products-collection-thumb',{staticClass:"mt-82 lg-mt-100 mx-auto max-w-400",attrs:{"rt":{name: 'products'},"image":_vm.image}},[_vm._v("Browse Our Catalogue")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }